import { Badge } from "react-bootstrap";
import { MdKeyboardReturn } from "react-icons/md";
import { TbCoins, TbTruckDelivery } from "react-icons/tb";
import { FaQuestionCircle, FaSwimmingPool } from "react-icons/fa";
import { BsBuildingsFill, BsFillFileEarmarkTextFill } from "react-icons/bs";


const SearchResultListItem = ({ item, onMouseEnter, active, selectHandler }) => {

    const iconSize = 20;
    const icons = {
        building: <BsBuildingsFill size={iconSize} />,
        poolrechnung: <FaSwimmingPool size={iconSize} />,
        abrechnung: <TbTruckDelivery size={iconSize} />,
        vorschreibung: <TbCoins size={iconSize} />,
        elv: <BsFillFileEarmarkTextFill size={iconSize} />,
    };
    const icon = icons[item.type] ?? <FaQuestionCircle size={iconSize} />;

    return (

        <li
            className={`search-results__item gap-2 ${
                active ? "search-results__item--active" : ""
            }`}
            onMouseEnter={onMouseEnter}
            role="option"
            aria-selected={active}
            onClick={() => selectHandler(item)}
        >
            {icon}
            <span>{item.text}</span>

            {active && (
                <div className="ms-auto d-flex align-items-center gap-1">
                    Auswählen 
                    <Badge bg="dark">
                        <MdKeyboardReturn />
                    </Badge>
                </div>
            )}
        </li>

    );
}
export default SearchResultListItem;